<template>
  <div>
    <Navbar />
    <div style="margin-top: 80px">
      <slot />
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/navs/Navbar.vue";
import Footer from "@/components/navs/Footer.vue";
import firebase from "firebase/compat/app";

export default {
  name: "DefaultLayout",
  components: {
    Navbar,
    Footer,
  },
  mounted() {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const token = await user.getIdToken();
          this.$axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${token}`;
        } catch (error) {
          // do nothing
        }
      }
    });
  },
};
</script>
